<template>
  <base-dialog :dialogVisible="dialogVisible" width="604px" :showClose="false"
               @handleConfirm="handleConfirm" @handleClose="handleClose" v-bind="$attrs">
    <template #title>{{title}}</template>
    <el-table :data="tableData" border style="width: 100%" height="192px" v-loading="tableLoading"
              header-cell-class-name="bankTaskTableHeaderCell" cell-class-name="bankTaskTableCell">
      <el-table-column prop="date" label="句段范围" width="180" align="center" show-overflow-tooltip>
        <template slot-scope="{row}">
          <span>{{row.startRow}}~{{row.endRow}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="userName" label="执行人" width="180" align="center"
                       show-overflow-tooltip />
      <el-table-column label="选择退回的范围" align="center" show-overflow-tooltip>
        <template slot-scope="{row}">
          <el-checkbox v-model="row.checked"></el-checkbox>
        </template>
      </el-table-column>
    </el-table>
    <template #confirm>{{confirmName}}</template>
  </base-dialog>
</template>

<script>
import { mapGetters } from 'vuex';
import { getQueryRollBackTask } from '@/services/editorApi';
export default {
  name: 'BankTaskSelectDialog',
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: '任务退回'
    },
    confirmName: {
      type: String,
      default: '退回'
    }
  },
  data () {
    return {
      tableData: [],
      tableLoading: true
    }
  },
  computed: {
    ...mapGetters('editor', [
      'getUrlInfo',
      'getFileInfo',
      'getFileTaskInfo',
      'getProjectInfo'
    ])
  },
  watch: {
    dialogVisible (newVal) {
      if (!newVal) return
      this.$nextTick(() => {
        this.getTableData()
      })
    }
  },
  methods: {
    // 退回任务句段范围列表
    async getTableData () {
      this.tableLoading = true
      const { type } = this.getUrlInfo
      const params = {}
      if (type === 'task') {
        const { fileId: id, id: taskId, taskType } = this.getFileTaskInfo
        Reflect.set(params, 'id', id)
        Reflect.set(params, 'taskType', taskType)
        Reflect.set(params, 'taskId', taskId)
      } else if (type === 'project') {
        const { projectProcessType: taskType } = this.getProjectInfo
        const { id } = this.getFileInfo
        Reflect.set(params, 'id', id)
        Reflect.set(params, 'taskType', taskType)
      }
      const { success, result } = await getQueryRollBackTask(params)
      if (!success) return
      this.tableData = result
      this.tableData.forEach(item => {
        this.$set(item, 'checked', false)
      })
      this.tableLoading = false
    },

    handleClose () {
      this.$emit('handleClose');
    },

    async handleConfirm () {
      const data = {
        dialogType: this.confirmName,
        checkedIdList: this.tableData.filter(item => item.checked).map(item => item.id)
      }
      if (data.checkedIdList.length > 0) {
        this.$emit('handleConfirm', data);
      } else {
        this.$message.closeAll()
        this.$message.error('请先勾选需要退回的任务句段范围')
      }
    }
  }
}
</script>

<style lang="less" scoped>
/deep/.el-dialog {
  line-height: 1.2;
  .el-dialog__header {
    padding-left: 55px;
    padding-right: 55px;
  }
  .el-dialog__body {
    padding: 0 55px;
    .el-table {
      .bankTaskTableHeaderCell {
        background-color: #f3f7fe;
        color: #303133;
      }
      .gutter {
        background-color: #f3f7fe;
      }
      .bankTaskTableCell {
        color: #303133;
      }
      .el-checkbox__inner {
        width: 16px;
        height: 16px;
        &::after {
          width: 4px;
          height: 7px;
          left: 4px;
          top: 2px;
        }
      }
    }
  }
  .el-dialog__footer {
    padding-top: 30px;
    padding-bottom: 30px;
    .close-btn {
      color: #0078fc;
      border-color: #0078fc;
    }
    .confirm-btn {
      color: #f53f3f;
      background-color: #fff;
      border-color: #f53f3f;
      &:hover {
        background-color: lighten(#f53f3f, 35%);
      }
    }
  }
}
</style>